// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__LveZR","logo":"Sidebar_logo__2RTuZ","menu":"Sidebar_menu__HjraT","link":"Sidebar_link__B9XVn","active":"Sidebar_active__23ctt"};